'use client';

import dynamic from 'next/dynamic';

export const AnalyticsBeacon = dynamic(
  () => import('./analytics-beacon'),
  { ssr: false },
);
